/** Textos da seção “Quando receber lembretes” em Configurações de lembretes. */

export const REMINDER_SETTINGS_SECTION_SUBTITLE =
  'Defina quando receber os lembretes e teste o envio no WhatsApp.';

export const REMINDER_SCHEDULE_SECTION_TITLE = 'Quando receber os lembretes';
export const REMINDER_SCHEDULE_SECTION_INTRO =
  'Até dois avisos por serviço, em relação à data prevista de manutenção. Escolha o horário do dia em que prefere ser lembrado.';

export const REMINDER_SCHEDULE_TIME_LABEL = 'Horário preferido';
export const REMINDER_SCHEDULE_TIME_HINT =
  'Os lembretes serão disparados neste horário (no seu fuso), quando couber na data calculada.';

export const REMINDER_SCHEDULE_FIRST_OFFSET_LABEL = 'Primeiro aviso (dias antes da manutenção)';
export const REMINDER_SCHEDULE_SECOND_OFFSET_LABEL = 'Segundo aviso (dias antes da manutenção)';
export const REMINDER_SCHEDULE_OFFSETS_HINT =
  'O primeiro valor deve ser maior que o segundo (ex.: 7 e 1). Use 0 para incluir o dia da manutenção.';

export const REMINDER_SCHEDULE_SAVE = 'Salvar preferências';
export const REMINDER_SCHEDULE_SAVING = 'Salvando…';
export const REMINDER_SCHEDULE_TOAST_OK = 'Preferências de lembretes salvas.';
export const REMINDER_SCHEDULE_ERR_OFFSET_ORDER =
  'O primeiro aviso precisa ser com mais antecedência que o segundo (número maior de dias).';
export const REMINDER_SCHEDULE_ERR_OFFSET_EQUAL =
  'Os dois avisos precisam ser em dias diferentes.';
export const REMINDER_SCHEDULE_ERR_OFFSET_RANGE = 'Use números inteiros entre 0 e 365.';
export const REMINDER_SCHEDULE_ERR_TIME = 'Informe um horário válido.';
